import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "@phosphor-icons/react";
import { Container, Overline } from "./Section";

export function PageHero({ overline, title, intro, back }) {
  return (
    <section className="bg-[#0B1B3D] text-white">
      <Container className="py-20 lg:py-28">
        <Link to="/" data-testid="page-back-link" className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors mb-12">
          <ArrowLeft size={16} weight="light" />
          {back}
        </Link>
        <Overline light testid="page-overline" className="mb-6">{overline}</Overline>
        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] max-w-4xl mb-8" data-testid="page-title">
          {title}
        </h1>
        <p className="text-base md:text-lg leading-relaxed text-white/70 max-w-2xl" data-testid="page-intro">{intro}</p>
      </Container>
    </section>
  );
}

export function PageBlock({ id, title, children, gray = false, testid }) {
  return (
    <section id={id} data-testid={testid} className={`py-20 lg:py-24 ${gray ? "bg-[#F4F5F7]" : "bg-white"}`}>
      <Container>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold tracking-tight text-[#0B1B3D] mb-12">{title}</h2>
        {children}
      </Container>
    </section>
  );
}

export function RelatedLinks({ label, links }) {
  return (
    <div data-testid="page-related" className="pt-10 border-t border-[#E2E8F0]">
      <p className="text-xs font-semibold tracking-[0.2em] uppercase text-[#9AA5B1] mb-5">{label}</p>
      <div className="flex flex-wrap gap-x-10 gap-y-3">
        {links.map((l) => (
          <Link key={l.href} to={l.href} className="inline-flex items-center gap-2 font-medium text-[#0B1B3D] hover:text-[#5A6B7C] transition-colors">
            {l.label}
            <ArrowRight size={16} weight="light" />
          </Link>
        ))}
      </div>
    </div>
  );
}

export function PageCta({ title, text, cta }) {
  return (
    <section className="py-20 lg:py-24 bg-[#F4F5F7] border-t border-[#E2E8F0]">
      <Container className="grid lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-8">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold tracking-tight text-[#0B1B3D] mb-4" data-testid="page-cta-title">{title}</h2>
          <p className="text-base md:text-lg text-[#5A6B7C]">{text}</p>
        </div>
        <div className="lg:col-span-4 lg:text-right">
          <Link
            to="/#contact"
            data-testid="page-cta-button"
            className="inline-flex items-center gap-3 bg-[#0B1B3D] text-white font-medium px-8 py-4 hover:bg-[#2A2D34] transition-colors"
          >
            {cta}
            <ArrowRight size={18} weight="light" />
          </Link>
        </div>
      </Container>
    </section>
  );
}
